// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3z93o","calendarButtons":"ClockData_calendarButtons__2uwsr"};